import template from './management_review_rating_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class ManagerReviewRatingHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.selected_tab = ko.observable('singleselect');

		this.selected_tab.subscribe((newCategory) => {
			$('.rating-methods > li').removeClass('active');
			$(`.rating-methods > li[data-tabname=${newCategory}]`).addClass('active');
		});

		$(`.rating-methods > li[data-tabname=${this.selected_tab()}]`).addClass('active');
	};

	switch_tabs(v, e)
	{
		let tabname = e.currentTarget.getAttribute('data-tabname');
		this.selected_tab(tabname);
	}

	close()
	{
		this.dialog.close();
	}
};

class ManagerReviewRatingHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ManagerReviewRatingHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ManagerReviewRatingHelp',
	dialog_class: ManagerReviewRatingHelpPage,
	template: template,
	template_filename: 'translation/dialogs/manger_review_rating_help',
	provider: 'ps'
};